<template>
    <v-router-link v-if="tariff" size="subheadling" :to="{ path: '/tariff/history' }">
        Тариф {{tariff.title}}
    </v-router-link>
    <v-router-link v-else size="subheadling" :to="{ name: 'tariff' }">
        Тариф не выбран
        <v-font-icon inherit v-margin.left="1">add_circle_outline</v-font-icon>
    </v-router-link>
</template>
<script>
import { numberWithSpaces } from '../../../helpers';
export default {
    name: 'balance',
    props: {
        tariff: Object,
    },
    methods: {
        numberWithSpaces,
    }
    
}
</script>


// WEBPACK FOOTER //
// Balance.vue?1d9de822